/**
 * Prevents the reCAPTCHA badge from loading by inserting a dummy badge element.
 * The reCAPTCHA script detects the badge element and skips injecting its own.
 * @returns {void}
 */
export function preventRecaptchaFileLoad() {
	if (document.querySelector('.grecaptcha-badge')) {
		return;
	}

	const $badge = document.createElement('div');
	$badge.classList.add('grecaptcha-badge');
	document.body.appendChild($badge);
}
